import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAdminFormsDashboard({ ...rest }) {
  const AsyncLoad = loadable(() => import("../AdminFormsDashboard"));
  console.log("Loading", AsyncAdminFormsDashboard.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAdminFormsDashboard;
